import React from "react";
import Projects from "./Projects";
import TeamMembers from "./TeamMembers";

function Sidebar() {
  return (
    <div className="sidebar">
      {/* <!-- Projects List --> */}
      <Projects />

      {/* <!-- Team Members --> */}
      <TeamMembers />
    </div>
  );
}

export default Sidebar;
